import React, { useState } from "react";
import { Box, Modal, Typography, Button } from "@mui/material";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { FontFamily } from "../../theme/fontFamily";
import { ThemeColor } from "../../theme/color";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: "420px",
  bgcolor: "background.paper",
  boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.16)",
  borderRadius: "20px",
  p: 4,
  outline: "none",
  border: "none",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 2.5,
};

function DeleteMsg(props) {
  const [deleteMsgopen, setdeleteMsgOpen] = useState(false);
  const handleOpen = () => {
    props.handledeleteMsgOpen();
  };

  const handleClose = () => {
    setdeleteMsgOpen(false);
    props.handledeleteMsgClose();
  };

  const title = `${(props.msg || "Deleted").trim()} Successfully`;

  return (
    <div>
      <Modal
        open={props.deleteMsgopen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{
              width: 96,
              height: 96,
              borderRadius: "50%",
              bgcolor: "rgba(40, 167, 69, 0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                width: 68,
                height: 68,
                borderRadius: "50%",
                bgcolor: "#28a745",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0px 6px 16px rgba(40, 167, 69, 0.35)",
              }}
            >
              <CheckRoundedIcon sx={{ color: "#fff", fontSize: 40 }} />
            </Box>
          </Box>

          <Typography
            fontFamily={FontFamily.Poppins}
            fontWeight={600}
            fontSize="1.35rem"
            color={ThemeColor.BLACK}
            align="center"
          >
            {title}
          </Typography>

          <Button
            variant="contained"
            fullWidth
            onClick={handleClose}
            sx={{
              bgcolor: "rgba(19, 85, 155, 1)",
              color: "white",
              borderRadius: "12px",
              py: 1.25,
              mt: 0.5,
              textTransform: "none",
              fontWeight: 600,
              fontFamily: FontFamily.Poppins,
              fontSize: "0.95rem",
              boxShadow: "none",
              "&:hover": {
                bgcolor: "rgba(19, 85, 155, 0.9)",
                boxShadow: "none",
              },
            }}
          >
            Continue
          </Button>
        </Box>
      </Modal>
    </div>
  );
}

export default DeleteMsg;
